import type { IconNode } from '../types';

/**
 * @name letter-a
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTcuMTE3IDE0SDYuODgzIiAvPgogIDxwYXRoIGQ9Im00IDIwIDcuNTUtMTUuNzEyYS41LjUgMCAwMS45IDBMMjAgMjAiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/letter-a
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const LetterA: IconNode = [
  ['path', { d: 'M17.117 14H6.883' }],
  ['path', { d: 'm4 20 7.55-15.712a.5.5 0 01.9 0L20 20' }],
];

export default LetterA;
